import React from 'react';
import {
    actualAttributes as attributesTitle,
    AttributesT,
} from '../../../../utils/constants';
import { SavedConfig } from '../../../SavedConfig/SavedConfig';
import { EmptyState } from '../EmptyState/EmptyState';
import s from './ReviewPanel.module.scss';
import { getAttributePrices } from '../../../../utils/priceHelpers';

interface ReviewPanelProps {
    isActive: boolean;
    hasLoaded: boolean;
    actualAttributes: any;
    actualPrice: number;
    modelName: string;
    pathname: string;
    onBackToConfig: () => void;
    onCheckout: () => void;
}

export const ReviewPanel: React.FC<ReviewPanelProps> = ({
    isActive,
    hasLoaded,
    actualAttributes,
    actualPrice,
    modelName,
    pathname,
    onBackToConfig,
    onCheckout,
}) => {
    // Get per-attribute prices from mock data + products.json (never wiped)
    const attrPrices = getAttributePrices(actualAttributes);
    // Build a quick lookup: name → { unitPrice, quantity }
    const priceLookup = new Map(attrPrices.map(p => [p.name, p]));

    return (
        <div className={`${s.shop} ${isActive ? s.active : ''}`}>
            <div className={s.shop_title__wrapper}>
                <div className={s.title}>Review your build</div>
                <div className={s.shop_save_config}>
                    <SavedConfig disableAr={true} />
                </div>
            </div>

            {/* Model summary card */}
            <div className={s.model_card}>
                <div className={s.model_card_name}>{modelName}</div>
                <div className={s.model_card_route}>
                    {pathname.replace('/', '')}
                </div>
            </div>

            {hasLoaded && actualAttributes ? (
                <>
                    <div className={s.string_title}>Accessories</div>
                    <div className={s.content}>
                        {Object.keys(actualAttributes).map((name: any) => {
                            const actualName: AttributesT = name;
                            const attr = actualAttributes[actualName];

                            if (!attr.activeItem || actualName === 'Paint color') {
                                return null;
                            }

                            const priceData = priceLookup.get(name);
                            const quantity = priceData?.quantity ?? (attr.shopInfo?.quantity ?? 1);
                            const unitPrice = priceData?.unitPrice ?? 0;
                            const isChanged = attr.defaultItem !== attr.activeItem;

                            return (
                                <div
                                    className={`${s.summary_row} ${isChanged ? s.summary_row_active : ''}`}
                                    key={`review-${name}`}
                                >
                                    <div className={s.summary_info}>
                                        <div className={s.summary_name}>
                                            {attributesTitle[actualName] ?? name}
                                        </div>
                                        <div className={s.summary_value}>
                                            {attr.activeItem}
                                        </div>
                                    </div>
                                    <div className={s.summary_price}>
                                        {`$${(unitPrice * quantity).toFixed(2)}`}
                                        {unitPrice > 0 && quantity > 1 && (
                                            <span className={s.summary_qty}>
                                                {' '}× {quantity}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            ) : (
                <EmptyState onStartConfiguring={onBackToConfig} />
            )}

            {hasLoaded && actualAttributes && (
                <div className={`${s.offer__wrapper} ${s.shop_content}`}>
                    <div className={s.total__wrapper}>
                        <div className={s.total_title}>Total Summary</div>
                        <div className={s.total_price}>${actualPrice}</div>
                    </div>
                    <div className={s.btn__wrapper}>
                        <div className={s.back_btn} onClick={onBackToConfig}>
                            Back to Config
                        </div>
                        <div
                            className={`${s.next_btn} ${actualPrice == 0 ? s.disable : ''}`}
                            onClick={onCheckout}
                        >
                            Go to Checkout
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
